@use "variables" as *;

.dialog {
  height: 100vh;
}

.shelvingDiv {
  display: grid;
  padding: $spacing-l;
  position: relative;
}

.shelving {
  display: grid;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto !important;
}

.zoomSlider {
  width: 100px;
  margin-right: $spacing-l;
}
